import { render, staticRenderFns } from "./HookTag.vue?vue&type=template&id=08168d07&scoped=true&"
import script from "./HookTag.vue?vue&type=script&setup=true&lang=js&"
export * from "./HookTag.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./HookTag.vue?vue&type=style&index=0&id=08168d07&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08168d07",
  null
  
)

export default component.exports